(function() { window.GUID_39f5e303_f83e_49b7_b23f_58cd2292573f = { getGuid: function() { return "39f5e303-f83e-49b7-b23f-58cd2292573f"; } }; })();
var CS;
(function (CS) {
    var Stream;
    (function (Stream) {
        function showStreamingPopup(extraData, onlyAddVideos, matchId) {
            const url = CS.Url.CSUrl("addstream");
            const data = {
                onlyAddVideos,
                videoMatchId: matchId,
            };
            let validVideo = false;
            //popup avec choix de essayer avec pub ou s'abbonner.  Devrait avoir un exemple et explication du feature
            CS.Controls.Popup.ShowAjaxModal(url, data, ({ popup }) => {
                console.log("showStreamingPopup shown");
                let service = "";
                let permissionsAllowed = false;
                $(".first-step").show();
                $(".permissions").hide();
                // OnLoad
                $("#button-existing-facebook").offon("click.popupstream", (e) => {
                    $(".first-step").hide();
                    $(".existing-container").show();
                    $(".existing-facebook-instructions").show();
                });
                $("#button-existing-youtube").offon("click.popupstream", (e) => {
                    $(".first-step").hide();
                    $(".existing-container").show();
                    $(".existing-youtube-instructions").show();
                });
                $("#button-facebook").offon("click.popupstream", (e) => {
                    $("#permission-facebook").show();
                    service = "facebook";
                    checkPermissions("facebook", popup, extraData);
                });
                $("#button-youtube").offon("click.popupstream", (e) => {
                    $("#permission-facebook").hide();
                    CS.NativeApp.NA_ShowNativeDebugInfo("youtube ");
                    service = "youtube";
                    permissionsAllowed = checkPermissions("youtube", popup, extraData);
                    CS.NativeApp.NA_ShowNativeDebugInfo("resolved " + permissionsAllowed);
                });
                $("#button-enable-permissions").offon("click.popupstream", (e) => {
                    askPermissions(service, popup, extraData);
                });
                $("#textbox-starttimeseconds").offon("keyup.popupstream", (e) => {
                    let time = $("#textbox-starttimeseconds input").val().trim();
                    let url = $("#textbox-permalink input").val().trim();
                    if (time == "") {
                        time = 0;
                    }
                    let queryParams = CS.Helper.GetQueryStringVars(url);
                    if (queryParams.has("t")) {
                        let t = queryParams.get("t");
                        url = url.replace("t=" + t, "t=" + time);
                    }
                    else {
                        url = url + (url.indexOf("?") == -1 ? "?t=" : "&t=") + time;
                    }
                    $("#textbox-permalink input").val(url);
                    $("#PermaLinkFixed").val(url);
                });
                $("#textbox-permalink").offon("paste.popupstream", (e) => {
                    $("#textbox-permalink").trigger("keyup");
                });
                $("#textbox-permalink").offon("keyup.popupstream", (e) => {
                    validVideo = false;
                    $(".existing-warning").hide();
                    $(".warning-not-handled").addClass("hidden");
                    CS.Lag("link.keyup", 200, () => {
                        let url = $("#textbox-permalink input").val().trim();
                        console.log("streamurl: " + url);
                        let id = "";
                        if (url.indexOf("http") != 0) {
                            url = "https://" + url;
                        }
                        let queryParams = CS.Helper.GetQueryStringVars(url);
                        if (queryParams.has("t")) {
                            let t = queryParams.get("t");
                            $("#textbox-starttimeseconds input").val(t);
                        }
                        let container = $("#popup-add-stream").find(".iframe-container");
                        if (url.indexOf("https://youtu") != -1 ||
                            url.indexOf("https://www.youtu") != -1) {
                            //url = url.replace('https://www.youtube.com/', 'https://www.youtube.com/embed/').replace('https://youtu.be/', 'https://www.youtube.com/embed/');
                            let newval = null;
                            if ((newval = url.match(/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/))) {
                                id = newval[1];
                                console.log("videoid=" + id);
                            }
                            console.log("processing YT");
                            container.data("id", 0);
                            container.data("videoid", id);
                            container.html(`<div id='player-0' class='player' />`);
                            container.css("padding-top", "calc(56.25%)");
                            container.addClass("iframe-yt");
                            container.addClass("add-video");
                            $("body").offon("YoutubeVideoLoaded.addvideo", (e, id) => {
                                validVideo = true;
                                $(".existing-warning").hide();
                                CS.Debug.Log("YT video can be played in app " + id + " " + e);
                            });
                            $(".stream-company").text("YouTube");
                            processYouTubePlayers();
                        }
                        else if (url.indexOf("https://www.facebook.com/plugins/video") == -1 &&
                            (url.indexOf("https://facebook.com") != -1 ||
                                url.indexOf("https://www.facebook.com") != -1 ||
                                url.indexOf("https://fb.") != -1)) {
                            $(".stream-company").text("Facebook");
                            container.removeClass("iframe-yt");
                            container.css("padding-top", "0");
                            console.log("CSS");
                            if (queryParams["v"]) {
                                id = queryParams["v"];
                            }
                            else {
                                url = encodeURI(url);
                                let newval = null;
                                if ((newval = url.match(/^(?:https?:\/\/)?(?:facebook\.com|fb(?:\.me|\.com|\.watch))\/|\S+\/\/\S+\/(\d+)\/?$/))) {
                                    id = RegExp.$1;
                                    console.log("fbid=" + id);
                                }
                            }
                            container.html(`<div class='fb-video' id='video-${id}' data-href='${url}' data-allowfullscreen='true' data-width='auto'></div>`);
                            $("body").offon("FacebookVideoLoaded.addvideo", (e, id) => {
                                validVideo = true;
                                $(".existing-warning").hide();
                                CS.Debug.Log("FB video can be played in app " + id + " " + e);
                            });
                            CS.App.Views._Shared.WallSections.handleFacebookVideos(container);
                        }
                        else {
                            //Not YT or FB
                            CS.Lag("not-handled-stream", 500, () => {
                                $(".warning-not-handled").removeClass("hidden");
                            });
                        }
                        console.log(url);
                        //$('.existing-container iframe').attr('src', url).show();
                        container.show();
                        $("#PermaLinkFixed").val(url);
                        $("#VideoId").val(id);
                        $("#VideoTitle").val(extraData.title);
                        $("#GameNumber").val(extraData.gameNumber);
                        $("#VideoDescription").val(extraData.description);
                        CS.Lag("valid-video", 1000, () => {
                            if (!validVideo) {
                                $(".existing-warning").show();
                            }
                        });
                        //$('#StreamHtml').val(encodeURIComponent($('.existing-container iframe')[0].outerHTML));
                        const $buttonSave = $("#button-save");
                        if (url && url.trim() != "") {
                            // $('#button-save').removeAttr('disabled');
                            CS.Helper.enableButton($buttonSave);
                        }
                        else {
                            // $('#button-save').addAttr('disabled');
                            CS.Helper.disableButton($buttonSave);
                        }
                    });
                });
                //if (CommonData.Current.IsNativeApp) {
                //    console.log(`CheckStreamingPermissions Facebook`);
                //    CheckStreamingPermissions("Facebook");
                //    $('body').on('CheckStreamingPermissionsResponse', function (eAsk, camera, microphone, service) {
                //        console.log(`CheckStreamingPermissionsResponse ${camera}`);
                //        if (camera && microphone && service) {
                //            permissionsAllowed = true;
                //        }
                //    });
                //}
            }, ({ popup }) => { }, true, false);
        }
        Stream.showStreamingPopup = showStreamingPopup;
        function checkPermissions(service, popup, extraData) {
            CS.NativeApp.NA_ShowNativeDebugInfo("check permissions " + service);
            let check = false;
            $("body").offon("CheckStreamingPermissionsResponse.popupstream", function (eAsk, cameraOk, microphoneOk, serviceOk) {
                CS.NativeApp.NA_ShowNativeDebugInfo("response check permissions " + cameraOk);
                console.log(`CheckStreamingPermissionsResponse ${cameraOk}`);
                if (cameraOk && microphoneOk && serviceOk) {
                    console.log(`CheckStreamingPermissionsResponse response true`);
                    check = true;
                    popup.Close(false);
                    askPermissions(service, popup, extraData);
                }
                else {
                    console.log(`CheckStreamingPermissionsResponse response false`);
                    $(".first-step").hide();
                    $(".permissions").show();
                    $("#title-add-stream").addClass("hide");
                    $("#title-add-stream--permissions").removeClass("hide");
                }
            });
            CS.NativeApp.NA_CheckStreamingPermissions(service);
            CS.NativeApp.NA_ShowNativeDebugInfo("after check permissions");
            return true;
        }
        function askPermissions(service, popup, extraData) {
            var _a, _b;
            CS.NativeApp.NA_ShowNativeDebugInfo("ask permissions " + service);
            $("body").offon("AskStreamingPermissionsResponse.popupstream", function (eAsk, camera, microphone, service) {
                console.log(`AskStreamingPermissionsResponse ${camera}`);
                if (camera && microphone && service) {
                    //ShowNativeDebugInfo("stream");
                    //let data = {
                    //    Service: 'facebook',
                    //    Title: extraData.title,
                    //    Description: extraData.description,
                    //    PublicVideo: true,
                    //    Tag: JSON.stringify({ EventId: extraData.eventId, MatchId: extraData.matchId })
                    //};
                    //let encoded = Base64.encode(JSON.stringify(data));
                    //FacebookStreaming(encoded);
                    popup.Close(false);
                }
            });
            let data = {
                Service: service,
                Title: extraData.title,
                Description: extraData.description,
                MatchId: (_a = extraData.matchId) !== null && _a !== void 0 ? _a : extraData.dynamicMatchId,
                GameId: extraData.gameNumber,
                PublicVideo: true,
                ReplaceAudio: false,
                Tag: JSON.stringify({
                    EventId: extraData.eventId,
                    MatchId: (_b = extraData.matchId) !== null && _b !== void 0 ? _b : extraData.dynamicMatchId,
                }),
            };
            let encoded = Base64.encode(JSON.stringify(data));
            CS.NativeApp.NA_AskStreamingPermissions(encoded);
        }
    })(Stream = CS.Stream || (CS.Stream = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-stream.js.map
